import { RouteOptions } from './../../../models/route-options';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-router-tabs',
  templateUrl: './router-tabs.component.html',
  styleUrls: [
    './router-tabs.component.less',
    './../tabs.component.less'
  ]
})

export class RouterTabsComponent implements OnInit {
  @Input() routeInfo: RouteOptions[];
  @Input() activeForChildren: boolean;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tabs/router-tabs/router-tabs.component.ts